import { render, staticRenderFns } from "./categories-table.vue?vue&type=template&id=07cb03f0&"
import script from "./categories-table.vue?vue&type=script&lang=ts&"
export * from "./categories-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports